import { Link } from "react-router-dom";

const footerLinks = [
  { to: "/news", label: "娱乐资讯" },
  { to: "/movies", label: "影视推荐" },
  { to: "/community", label: "互动社区" },
  { to: "/about", label: "关于我们" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-950 text-background-100">
      <div className="px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-extrabold tracking-wide text-background-50">色花堂</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              色花堂是一个集娱乐资讯、影视推荐与互动社区于一体的综合娱乐平台，致力于为每一位娱乐爱好者提供新鲜、有趣、有价值的娱乐内容，让发现与分享变得更简单。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">内容导航</h4>
            <ul className="mt-4 flex flex-col gap-2">
              {footerLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 transition-colors hover:text-primary-400 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">联系我们</h4>
            <ul className="mt-4 flex flex-col gap-2 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base" aria-hidden="true"></i>
                <span>hello@sehuatang.example</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-base" aria-hidden="true"></i>
                <span>色花堂娱乐</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-base" aria-hidden="true"></i>
                <span>每日 09:00 - 22:00 更新</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 色花堂 · 综合娱乐平台 · 本站内容为演示示例，仅供学习交流</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>娱乐资讯 · 影视推荐 · 社区交流</span>
          </p>
        </div>
      </div>
    </footer>
  );
}